module.exports = __webpack_public_path__ + "img/x4.cf354406.png";